<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">Меню үүсгэх</h2>
        </div>
      </div>
    </div>

    <div class="row my-3">
      <div class="card w-100">
        <div class="card-header">
          <div class="row form-group">
            <div class="col col-md-1">
              <label for="text-input" class="form-control-label">Нэр*</label>
            </div>
            <div class="col-12 col-md-4">
              <input
                type="text"
                id="text-input"
                name="text-input"
                class="form-control"
                v-on:input="onChangeHandler('name', $v.name)"
                :class="{ 'form-control is-invalid': $v.name.$error }"
                v-model="name"
              >
              <div class="invalid-feedback">{{ this.getErrorMsg('name')[0] }}</div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="default-tab">
            <div class="d-flex">
              <div
                :class="[{ 'tab--selected' : languageTab === 'MN', 'tab--invalid': mnTabError && languageTab !== 'MN' }, 'nav-link tab']"
                @click="languageTab = 'MN'"
              >MON</div>
              <div
                :class="[{ 'tab--selected' : languageTab === 'EN', 'tab--invalid': enTabError && languageTab !== 'EN' }, 'nav-link tab']"
                @click="languageTab = 'EN'"
              >ENG</div>
            </div>
            <br>
            <!-- MN tab -->
            <div v-if="languageTab === 'MN'">
              <div class="row mt-3 form-group">
                <div class="col col-md-2">
                  <label for="text-input" class="form-control-label">Гарчиг*</label>
                </div>
                <div class="col-12 col-md-10">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('title.0', $v.mntitle)"
                    :class="{ 'form-control is-invalid': $v.mntitle.$error }"
                    v-model="mntitle"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('title.0')[0] }}</div>
                </div>
              </div>
            </div>
            <!-- EN tab -->
            <div v-else-if="languageTab === 'EN'">
              <div class="row mt-3 form-group">
                <div class="col col-md-2">
                  <label for="text-input" class="form-control-label">Гарчиг</label>
                </div>
                <div class="col-12 col-md-10">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('title', $v.entitle)"
                    :class="{ 'form-control is-invalid': $v.entitle.$error }"
                    v-model="entitle"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('title.1')[0] }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
          <router-link to="/submenu">
            <button type="submit" class="btn btn-primary mx-2">Буцах</button>
          </router-link>
          <button @click="onSubmit" type="submit" class="btn btn-success">
            <i class="fa fa-dot-circle-o"></i> Хадгалах
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuService from "@/services/MenuService";
import Form from "@/mixins/Form.js";

export default {
  name: "TopmenuCreate",

  mixins: [Form],

  computed: {
    mnTabError() {
      return this.$v.mntitle.$error;
    },

    enTabError() {
      return this.$v.entitle.$error;
    }
  },

  data() {
    return {
      name: "",
      mntitle: "",
      entitle: ""
    };
  },

  validations: {
    name: {
      serverFailed: function() {
        return !this.hasServerError("name");
      }
    },
    mntitle: {
      serverFailed: function() {
        return !this.hasServerError("title.0");
      }
    },
    entitle: {
      serverFailed: function() {
        return !this.hasServerError("title.1");
      }
    }
  },

  methods: {
    serverRequest: MenuService.createTopmenu,

    successHandler(response) {
      if (response.data.payload.toast != null)
        this.showToast(response.data.payload.toast);

      this.$router.push("/submenu");
    },

    createJsonData() {
      let data = JSON.parse("{}");
      data.name = this.name;
      data.contents = [];

      let mncontent = JSON.parse("{}");
      mncontent.language = 1;
      mncontent.title = this.mntitle;
      data.contents.push(mncontent);

      if (this.hasEngdata()) {
        let encontent = JSON.parse("{}");
        encontent.language = 2;
        encontent.title = this.entitle;
        data.contents.push(encontent);
      }
      return data;
    },

    hasEngdata() {
      return this.entitle != "";
    }
  }
};
</script>
